import React from 'react';
import './LandingPage.css';

export default function AddMember() {
  return (
    <main className="container" style={{ padding: 24 }}>
      <h1>Add Member</h1>
      <p>Form/page to add a member (placeholder).</p>
    </main>
  );
}
